import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { SortModel } from "components/data/DataSource";
import { WebApiDataSource } from "components/data/WebApiDataSource";
import { Link } from "react-router-dom";
import { SeznamPartneru as apiSeznamPartneru, Par } from "common/api/Evidence/Pary/Pary";
import DataGrid, { Column, DataGridProps } from "components/controls/DataGrid";
import Label from "common/components/controls/Label";

//import { detail as pathDetail, RouteProps } from "./routes-path";

interface SeznamPartneruProps {
    clenId: number;
    paryRootPath: string;
}

class SeznamPartneru extends React.PureComponent<SeznamPartneruProps> {

    private dataSource: WebApiDataSource<Par>;
    private columns: Column<Par>[];

    constructor(props: SeznamPartneruProps) {
        super(props);

        this.dataSource = new WebApiDataSource(this.getDataAction);
        this.dataSource.setPageSize(20, true);

        const sortedItems: { [index: string]: SortModel } = {
            ['Id']: { field: 'Id', direction: 'desc' }
        }

        this.dataSource.setSortedItems(sortedItems);

        this.columns = [
            { headerText: "Jméno", field: "_jmeno", render: this.renderJmeno },
            { headerText: "Standard", field: "_stt", render: this.renderStav(true), width: 100 },
            { headerText: "Latina", field: "_lat", render: this.renderStav(false), width: 100 },
            { field: "_detail", width: 80, render: this.renderDetail },
        ];
    }

    renderStav = (stt: boolean) => (col: Column<Par>, row: Par) => {
        if (stt)
            return row.Stt ? this.getStav(row.Stt.Stav) : null;
        else
            return row.Lat ? this.getStav(row.Lat.Stav) : null;
    }

    renderDetail = (col: Column<Par>, row: Par) => {
        const { paryRootPath } = this.props;
        let link;
        if (row.Id == 0) {
            const id = row.Stt ? row.Stt.Id : row.Lat.Id;
            link = paryRootPath + '/detail-ds/' + id;

        } else {
            link = paryRootPath + '/detail/' + row.Id;
        }
        return <a href={link}>{'Detail'}</a>; //  <Link to={link}>Detail</Link>;
    }

    renderJmeno = (col: Column<Par>, row: Par) => {
        const { clenId } = this.props;
        const { Partner, Partnerka } = row;

        return clenId === Partner.Id
            ? `${Partnerka.Prijmeni} ${Partnerka.Jmeno}`
            : `${Partner.Prijmeni} ${Partner.Jmeno}`;

    }

    getStav = (stav: number) => {
        if (stav == 0) return <Label color="warning" label="registrace" />
        else if (stav == 1) return <Label color="success" label="aktivní" />
        else return <Label color="danger" label="ukončeno" />
    };


    getDataAction = () => {
        return apiSeznamPartneru(this.props.clenId);
    }

    render() {
        const dgProps: DataGridProps<Par> = {
            dataSource: this.dataSource,
            columns: this.columns,
            //  query: this.query,
            paginationSettings: {
                pageCount: 5,
                //allowItemsCountInfo: true,
                autoHide: true,
            },
            allowPaging: true,
            //allowResizing: true,
            //allowSorting: true,
            //height: 'grow',
            // height: 300,
            // autoFitColumns:[]

            padding: 'default',
            //  padding: 'dense',
            // gridLines: 'both',
            showBorder: false,
            noItemsContent: <em>{'- nejsou evidováni žádní partneři(ky) -'}</em>,
        }

        return <div>
            <DataGrid {...dgProps} />
        </div>;
    }
}


export default SeznamPartneru;